<div
    class="relative rounded p-4 lg:p-6 mb-4 flex lg:flex-row flex-col gap-4 shadow-md"
    [ngClass]="{
            'bg-white': !entity?.darkMode,
            'bg-gray-800': entity?.darkMode,
            'text-white': entity?.darkMode,
            'text-black': !entity?.darkMode,
        }">
    <div class="grow flex flex-col gap-4">
        <a [routerLink]="['/jobs', job.slug]">
            <h2 class="text-xl lg:text-2xl font-bold">{{ job.title }}</h2>
        </a>
        <div class="lg:flex hidden h-8 gap-2">
            <div
                *ngIf="job.category && !component.cards?.hideCategory"
                class="text-xs font-bold p-2"
                [ngClass]="component?.cards?.categoryHighlightColour || 'bg-transparent'">
                {{ job.category | titlecase }}
            </div>
            <div
                *ngIf="job.businessUnit && !component.cards?.hideBusinessUnit"
                class="text-xs font-bold p-2"
                [ngClass]="component?.cards?.categoryHighlightColour || 'bg-transparent'">
                {{ job.businessUnit | titlecase }}
            </div>
            <div *ngIf="job.type && !component.cards?.hideJobType" class="text-xs font-bold p-2">{{ job.type | titlecase }}</div>
            <div *ngIf="locationString" class="text-xs font-bold p-2">{{ locationString }}</div>
            <div *ngIf="job.reference" class="text-xs font-bold p-2">{{ job.reference }}</div>
        </div>
        <div class="text-sm" *ngIf="!component.cards?.hideSummary && !component.cards?.preferSummaryOrDescription">
            {{ job.summary?.en || job?.content?.en | stripTags | slice : 0 : 200 }}...
        </div>
        <div class="text-sm" *ngIf="!component.cards?.hideSummary && component.cards?.preferSummaryOrDescription === 'summary'">
            {{ job.summary?.en | stripTags | slice : 0 : 200 }}...
        </div>
        <div class="text-sm" *ngIf="!component.cards?.hideSummary && component.cards?.preferSummaryOrDescription === 'description'">
            {{ job?.content?.en | stripTags | slice : 0 : 200 }}...
        </div>
        <div
            class="lg:hidden h-8"
            [ngClass]="{
            'text-gray-500': entity?.darkMode,
        }">
            <span class="text-xs font-medium">{{ locationString | uppercase }}</span>
            <span class="text-xs font-medium"> | {{ job.type | uppercase }}</span>
            <span *ngIf="job.reference" class="text-xs font-medium"> | {{ job.reference | uppercase }}</span>
        </div>
        <div class="w-[75px]" *ngIf="!component.cards?.hideLogo && logoImg">
            <advanced-image width="75" height="75" [cldImg]="logoImg" [plugins]="plugins"></advanced-image>
        </div>
    </div>
    <div class="hidden lg:block lg:min-w-[250px] aspect-[4:3]" *ngIf="!component.cards?.hideMedia && thumbnail">
        <advanced-image width="250" height="187" [cldImg]="thumbnail" [plugins]="plugins"></advanced-image>
    </div>
    <div *ngIf="!component.cards?.hideMedia && imageUrl">
        <img class="h-full" [src]="imageUrl" [alt]="job.title" width="250" height="187" />
    </div>
</div>
